import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setSchoolDetails,
    setloading,
    seterror,
    resetSchoolDetails,
} from "../reducers/getSchoolDetailsReducer";

const getSchoolDetails = (id: any, token: any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const result = await api.get(`super-admin/school/${id}/`, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {

            dispatch(setloading(false));
            dispatch(setSchoolDetails(result?.data));
        }
    } catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
};

export { getSchoolDetails, resetSchoolDetails };